<div class="tw-min-h-screen tw-bg-slate-50 tw-py-12 tw-px-4">
  <div class="tw-max-w-3xl tw-mx-auto" *ngIf="usuarioRol">

    <div class="tw-mb-8">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900" *ngIf="usuarioRol == 'empresa'">{{perfilEmpresa.nombreComercial}}</h1>
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900" *ngIf="usuarioRol == 'candidato'">{{perfilCandidato.nombre + ' ' + perfilCandidato.apellidos}}</h1>
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900" *ngIf="!usuarioRol">Mi Perfil</h1>
      <p class="tw-mt-1 tw-text-slate-500 tw-text-sm">Edita tu información de perfil</p>
    </div>

    <form [formGroup]="formPerfil" (ngSubmit)="validarDatosPerfil()">
      <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">

        <div class="tw-flex tw-items-center tw-justify-between tw-mb-5">
          <h2 class="tw-text-base tw-font-semibold tw-text-slate-800">Datos Generales</h2>
          <a *ngIf="usuarioRol == 'empresa'" routerLink="/crear-vacante"
            class="tw-text-sm tw-font-medium tw-text-blue-600 hover:tw-underline">
            Publicar Vacante
          </a>
        </div>

        <div class="tw-mb-5" *ngIf="usuarioRol == 'empresa'">
          <div class="tw-flex tw-items-center tw-gap-4 tw-flex-wrap">
            <img loading="lazy" [src]="perfilEmpresa.logo" [alt]="perfilEmpresa.nombreComercial" [title]="perfilEmpresa.nombreComercial" class="tw-w-20 tw-h-20 tw-rounded-xl tw-object-cover tw-border tw-border-slate-100"
                 onerror="this.onerror=null;this.src='/assets/img/user/empresa-default.png'">
            <label class="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-cursor-pointer tw-transition hover:tw-border-blue-400"
              title="Sólo permite archivos de tipo: .jpeg, jpg, .png, .ico y .tif. El peso máximo debe ser de {{((pesoLogo / 1000) | number: '0.00')}} KB.">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4 tw-text-slate-500"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"/></svg>
              <span>Elegir Logo</span>
              <input type="file" id="logo" name="logo" accept="image/*" (change)="subirLogo($event)" class="tw-hidden">
            </label>
          </div>
          <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="!esImagen">
            Los archivos con la extensión permitidos son: .jpeg, jpg, .png, .ico y .tif.
          </div>
          <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="excedePeso">
            El archivo excede el peso máximo de {{ ((pesoLogo / 1000) | number: '0.00') }} KB, por favor suba otro archivo.
          </div>
        </div>

        <div class="tw-mb-5" *ngIf="usuarioRol == 'candidato'">
          <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">
            <div>
              <div class="tw-flex tw-items-center tw-gap-4 tw-flex-wrap"
                title="Sólo permite archivos de tipo: .jpeg, jpg, .png, .ico y .tif. El peso máximo debe ser de {{((pesoLogo / 1000) | number: '0.00')}} KB.">
                <img loading="lazy" [src]="perfilCandidato.avatar" [alt]="perfilCandidato.nombre" [title]="perfilCandidato.nombre" class="tw-w-20 tw-h-20 tw-rounded-xl tw-object-cover tw-border tw-border-slate-100"
                     onerror="this.onerror=null;this.src='/assets/img/user/candidato-default.png'">
                <label class="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-cursor-pointer tw-transition hover:tw-border-blue-400">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4 tw-text-slate-500"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"/></svg>
                  <span>Subir foto</span>
                  <input type="file" id="avatar" name="avatar" accept="image/*" (change)="subirImagen($event)" class="tw-hidden">
                </label>
              </div>
              <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="!esImagen">
                Los archivos con la extensión permitidos son: .jpeg, jpg, .png, .ico y .tif.
              </div>
              <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="excedePeso">
                El archivo excede el peso máximo de {{ ((pesoLogo / 1000) | number: '0.00') }} KB, por favor suba otro archivo.
              </div>
            </div>
            <div>
              <a routerLink="/mis-cvs"
                class="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-p-4 tw-rounded-2xl tw-no-underline tw-transition hover:tw-opacity-90"
                style="background:linear-gradient(135deg,#1e3a5f 0%,#1d4ed8 100%);color:#fff">
                <span style="font-size:13px;font-weight:700;letter-spacing:.5px;opacity:.8;text-transform:uppercase">Tu CV con IA</span>
                <span style="font-size:14px;font-weight:600;line-height:1.45">Sube tu CV y mejóralo con IA — además encuentra las vacantes ideales para ti con la ayuda de la I.A.</span>
                <span style="margin-top:4px;font-size:12px;font-weight:600;background:rgba(255,255,255,.2);padding:4px 12px;border-radius:100px">Ir a Mis CVs →</span>
              </a>
            </div>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">

          <div *ngIf="usuarioRol == 'empresa'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Nombre Comercial</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="nombreComercial">
          </div>

          <div *ngIf="usuarioRol == 'empresa'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Razón Social</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="razonSocial">
          </div>

          <div *ngIf="usuarioRol == 'empresa'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Giro Empresarial</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="giroEmpresarial">
              <option hidden disabled selected [value]="">{{perfilEmpresa.giroEmpresarial}}</option>
              <option value="Industrial">Industrial</option>
              <option value="Manufactura">Manufactura</option>
              <option value="Comercial">Comercial</option>
              <option value="Servicios">Servicios</option>
            </select>
          </div>

          <div *ngIf="usuarioRol == 'empresa'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Giro Específico</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="giroEspecifico">
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Nombre</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="nombre">
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Apellidos</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="apellidos">
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Fecha Nacimiento</label>
            <input type="date" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="fechaNacimiento">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formPerfil.controls.fechaNacimiento.errors && (formPerfil.controls.fechaNacimiento.pristine || formPerfil.controls.fechaNacimiento.untouched)">
              <div *ngIf="formPerfil.controls.fechaNacimiento.errors.required">Por Favor selecciona una opción antes de Continuar.</div>
            </div>
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Género</label>
            <div class="tw-flex tw-items-center tw-gap-5 tw-mt-1">
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="masculino" name="genero" value="Masculino" formControlName="genero" class="tw-text-blue-600">
                Masculino
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="femenino" name="genero" value="Femenino" formControlName="genero" class="tw-text-blue-600">
                Femenino
              </label>
            </div>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formPerfil.controls.genero.errors && (formPerfil.controls.genero.pristine || formPerfil.controls.genero.untouched)">
              <div *ngIf="formPerfil.controls.genero.errors.required">Por Favor selecciona una opción antes de Continuar.</div>
            </div>
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Disponibilidad para viajar</label>
            <div class="tw-flex tw-items-center tw-gap-5 tw-mt-1">
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dViajarSi" name="dViajar" value="Si" formControlName="dViajar" class="tw-text-blue-600">
                Si
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dViajarNo" name="dViajar" value="No" formControlName="dViajar" class="tw-text-blue-600">
                No
              </label>
            </div>
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Disponibilidad para Mudarse</label>
            <div class="tw-flex tw-items-center tw-gap-5 tw-mt-1">
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dMudaSi" name="dMudar" value="Si" formControlName="dMudar" class="tw-text-blue-600">
                Si
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dMudaNo" name="dMudar" value="No" formControlName="dMudar" class="tw-text-blue-600">
                No
              </label>
            </div>
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Salario Deseado</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" maxlength="10" formControlName="salarioDeseado">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formPerfil.controls.salarioDeseado.errors && (formPerfil.controls.salarioDeseado.dirty || formPerfil.controls.salarioDeseado.touched)">
              <div *ngIf="formPerfil.controls.salarioDeseado.errors.pattern">El salario deben ser solo números formato permitido '99999.99'.</div>
            </div>
          </div>

          <div *ngIf="usuarioRol == 'candidato'" class="tw-min-w-0 tw-p-4 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1">WhatsApp <span class="tw-text-slate-400 tw-font-normal">(opcional)</span></label>
            <p class="tw-text-xs tw-text-slate-400 tw-mb-2">
              {{ waStatus.whatsappPhoneSet
                ? 'Puedes usar este número para iniciar sesión, además de tu correo, Google o LinkedIn.'
                : 'Verifícalo para poder entrar también con WhatsApp — tu correo, Google o LinkedIn siguen funcionando igual.' }}
            </p>

            <div *ngIf="!waEditing" class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
              <ng-container *ngIf="waStatus.whatsappPhoneSet; else noWaSet">
                <svg class="tw-w-4 tw-h-4 tw-flex-shrink-0" style="color:#16a34a" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                <span class="tw-text-sm tw-text-slate-700">+{{ waStatus.whatsappPhone }}</span>
              </ng-container>
              <ng-template #noWaSet>
                <span class="tw-text-sm tw-text-slate-500">Sin WhatsApp verificado</span>
              </ng-template>
              <button type="button" (click)="openWaEditor()"
                      class="tw-ml-auto tw-text-xs tw-text-blue-600 tw-underline tw-bg-transparent tw-border-0 tw-cursor-pointer">
                {{ waStatus.whatsappPhoneSet ? 'Cambiar número' : 'Verificar WhatsApp' }}
              </button>
            </div>

            <div *ngIf="waEditing" class="tw-space-y-3">
              <p *ngIf="waStep === 'phone'" class="tw-text-xs tw-text-slate-500">
                {{ waStatus.whatsappPhoneSet ? 'Si cambiaste de teléfono, verifica tu número nuevo.' : 'Verifica tu WhatsApp para usarlo la próxima vez que inicies sesión.' }}
              </p>

              <div *ngIf="waStep === 'phone'" class="tw-flex tw-items-center tw-gap-2">
                <select [(ngModel)]="selectedDialCode" [ngModelOptions]="{standalone: true}"
                        class="tw-py-2.5 tw-px-2 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-bg-white tw-font-medium tw-text-slate-600 tw-outline-none">
                  <option *ngFor="let c of waCountries" [value]="c.dial">{{ c.flag }} +{{ c.display }}</option>
                </select>
                <input type="tel" inputmode="numeric" [ngModel]="waPhoneNumber" (ngModelChange)="onWaPhoneChange($event)"
                       [ngModelOptions]="{standalone: true}" maxlength="15"
                       placeholder="1122334455"
                       class="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none"
                       (keyup.enter)="sendWaOtp()">
              </div>

              <div *ngIf="waStep === 'otp'" class="tw-text-center">
                <p class="tw-text-xs tw-text-slate-500 tw-mb-2">Código enviado a +{{ waFullPhone }}</p>
                <input type="text" [ngModel]="waOtpCode" (ngModelChange)="onWaOtpChange($event)"
                       [ngModelOptions]="{standalone: true}" [disabled]="waVerifyingOtp"
                       maxlength="6" inputmode="numeric" autocomplete="one-time-code"
                       placeholder="000000"
                       class="tw-w-40 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-lg tw-text-center tw-tracking-[6px] tw-font-mono tw-outline-none tw-mx-auto"
                       (keyup.enter)="verifyWaOtp()">
              </div>

              <p *ngIf="waMsg" class="tw-text-xs" [style.color]="waMsgIsError ? '#dc2626' : '#059669'">{{ waMsg }}</p>

              <div class="tw-flex tw-gap-2">
                <button type="button" (click)="closeWaEditor()"
                        class="tw-flex-1 tw-py-2 tw-rounded-xl tw-text-slate-600 tw-font-medium tw-text-sm tw-border tw-border-slate-200 tw-bg-white tw-cursor-pointer">
                  Cancelar
                </button>
                <button *ngIf="waStep === 'phone'" type="button" (click)="sendWaOtp()" [disabled]="waSendingOtp"
                        class="tw-flex-1 tw-py-2 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                        [style.background]="waSendingOtp ? '#94a3b8' : '#25D366'">
                  {{ waSendingOtp ? 'Enviando...' : 'Enviar código' }}
                </button>
                <button *ngIf="waStep === 'otp'" type="button" (click)="verifyWaOtp()" [disabled]="waVerifyingOtp || waOtpCode.length < 6"
                        class="tw-flex-1 tw-py-2 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                        [style.background]="(waVerifyingOtp || waOtpCode.length < 6) ? '#94a3b8' : '#25D366'">
                  {{ waVerifyingOtp ? 'Verificando...' : 'Verificar' }}
                </button>
              </div>
              <button *ngIf="waStep === 'otp'" type="button" (click)="resendWaOtp()" [disabled]="waResendCooldown > 0 || waSendingOtp"
                      class="tw-text-xs tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer tw-mx-auto tw-block"
                      [style.color]="(waResendCooldown > 0 || waSendingOtp) ? '#94a3b8' : '#25D366'">
                {{ waResendCooldown > 0 ? 'Reenviar código en ' + waResendCooldown + 's' : 'Reenviar código' }}
              </button>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Correo Electrónico</label>
            <input type="email" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="correo">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formPerfil.controls.correo.errors && (formPerfil.controls.correo.dirty || formPerfil.controls.correo.touched)">
              <div *ngIf="formPerfil.controls.correo.errors.pattern">El correo no es válido.</div>
            </div>
          </div>

          <div class="tw-min-w-0">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Teléfono de contacto</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition"
              minlength="10" maxlength="12" formControlName="telefono"
              [initialCountry]="telefono" #telefono appIntlTelInput
              (countrychange)="obtenerCodigoPais($event)">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formPerfil.controls.telefono.errors && (formPerfil.controls.telefono.pristine || formPerfil.controls.telefono.untouched)">
              <div *ngIf="formPerfil.controls.telefono.errors.required">Por Favor Ingresa un Número de Telefono antes de Continuar.</div>
              <div *ngIf="formPerfil.controls.telefono.errors.pattern">Deben ser solo números.</div>
              <div *ngIf="formPerfil.controls.telefono.errors.minlength">El número debe contener al menos 10 dígitos.</div>
              <div *ngIf="formPerfil.controls.telefono.errors.maxlength">El número debe contener máximo 12 dígitos.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">País*</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="pais" (change)="seleccionarPais($event.target.value)">
              <option *ngFor="let pais of paises">{{pais.name}}</option>
            </select>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="validandoPais && !pais">
              Debe seleccionar un País.
            </div>
          </div>

          <div *ngIf="pais == 'México'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Estado</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="estado" (change)="seleccionarEstado()">
              <option hidden selected [value]="0">{{(estadoInicial != null ? estadoInicial: 'Seleccione el nuevo Estado')}}</option>
              <option *ngFor="let estado of estados" [value]="estado.id">{{estado.nombre}}</option>
            </select>
          </div>

          <div *ngIf="ciudades && pais == 'México'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5" *ngIf="formPerfil.value.estado != 09">Municipio*</label>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5" *ngIf="formPerfil.value.estado == 09">Alcaldía*</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="ciudad">
              <option hidden selected [value]="0">{{(ciudadInicial != null ? ciudadInicial: "Seleccione "+(formPerfil.value.estado==09?"la nueva Alcaldía.":"el nuevo Municipio."))}}</option>
              <option *ngFor="let ciudad of ciudades" [value]="ciudad.claveCiudad">{{ciudad.nombre}}</option>
            </select>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="seleccionoEstado">
              {{"Debe seleccionar "+(formPerfil.value.estado==09?"una Alcaldía.":" un Municipio.")}}
            </div>
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Especialización</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="categoria">
              <option hidden disabled selected [value]="0">{{categoriaInicial}}</option>
              <option *ngFor="let categoria of categorias" [value]="categoria.idCategoria">{{categoria.nombreCategoria}}</option>
            </select>
          </div>

          <div *ngIf="usuarioRol == 'candidato'">
            <label class="tw-inline-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-mt-6">
              <input class="tw-w-4 tw-h-4 tw-rounded tw-border-slate-300 tw-text-blue-600" value="" type="checkbox" (change)="editarVisibilidadCandidato()" formControlName="visibilidadDatos">
              <span class="tw-text-sm tw-text-slate-700">Mostrar mis datos a las empresas</span>
            </label>
          </div>

          <div *ngIf="usuarioRol == 'empresa'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Dirección</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="direccion">
          </div>

          <div *ngIf="usuarioRol == 'empresa'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Página web</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="urlWeb">
          </div>

        </div>

        <div class="tw-mt-5">
          <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mb-3" *ngIf="selecCiudad">
            {{"Debe seleccionar "+(formPerfil.value.estado==09?"una Alcaldía.":"un Municipio.")}}
          </div>
          <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mb-3" *ngIf="selecEstado">
            Debe seleccionar un Estado.
          </div>
          <button type="submit"
            class="tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-transition"
            style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
            Actualizar Perfil
          </button>

          <!-- Selector de zona horaria -->
          <div class="tw-mt-6 tw-pt-4 tw-border-t tw-border-slate-200">
            <app-timezone-selector [rol]="usuarioRol === 'empresa' ? 'empresa' : 'candidato'"></app-timezone-selector>
          </div>
        </div>

      </div>
    </form>

    <div class="tw-mt-6 tw-flex tw-flex-col tw-gap-6">
      <app-network-social-candidate *ngIf="usuarioRol == 'candidato'" #networkSocialCandidate></app-network-social-candidate>
      <app-education-candidate *ngIf="usuarioRol == 'candidato'"></app-education-candidate>
      <app-experience-candidate *ngIf="usuarioRol == 'candidato'"></app-experience-candidate>
      <app-certificate-candidate *ngIf="usuarioRol == 'candidato'"></app-certificate-candidate>
      <app-ability-candidate *ngIf="usuarioRol == 'candidato'"></app-ability-candidate>
      <app-language-candidate *ngIf="usuarioRol == 'candidato'"></app-language-candidate>
      <app-password-profile [authProvider]="(usuarioRol === 'empresa' ? perfilEmpresa?.authProvider : perfilCandidato?.authProvider)"></app-password-profile>
    </div>

  </div>
</div>
